// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1Z7Ke","header":"styles_header__2OzEz","form":"styles_form__2lJBq","button_wrapper":"styles_button_wrapper__1vyAc"};